/* src/app/components/dialogs/add-field/add-field.component.scss */
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 500px;
  min-height: 300px;
  max-height: 350px;
  padding: 24px;
  margin-top: 10px !important;
}
.radio-group {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  gap: 10px;
  width: 33%;
}
.mat-mdc-radio-button {
  margin: 5px 16px;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
/*# sourceMappingURL=add-field.component.css.map */
